import * as React from 'react';
import treeCounterIcon from '../../../assets/icons/tree_validated_small.svg?url'

interface TreeCounterProps{
  treeCount?: number;
  onClick?: () => void;
}

interface TreeCounterState{
  treeCount: number;
  fromRef?: boolean;
}

export default class TreeCounter extends React.Component<TreeCounterProps, TreeCounterState>{
  constructor(props: TreeCounterProps) {
    super(props);
    this.state = {
      treeCount: props.treeCount ? parseInt(String(props.treeCount)) : 0,
    }
  }

  // static getDerivedStateFromProps(props: TreeCounterProps, state: TreeCounterState) {
  //   const { fromRef } = state;
  //   const treeCountFromProps = props.treeCount ? parseInt(String(props.treeCount)) : 0;
  //   return {
  //     treeCount: fromRef ? parseInt(String(state.treeCount)) : treeCountFromProps
  //   };
  // }

  updateTrees(increment: number) {
    const { treeCount } = this.state;
    this.setState({
      treeCount: parseInt(String(treeCount)) + parseInt(String(increment)),
      fromRef: true
    })
  }

  setTrees(treeCount: number) {
    this.setState({
      treeCount: parseInt(String(treeCount)), fromRef: true
    })
  }

  render() {
    const { onClick } = this.props;
    let { treeCount } = this.state;
    if (treeCount < 0) {
      treeCount = 0;
    }

    return (
      <div key={'tree-counter'} className={'tree-counter' + (onClick ? ' clickable' : '')} onClick={onClick}>
        <div className={'tree-counter-contents'}>
          <div><img src={treeCounterIcon} /></div>
          <div>{treeCount}</div>
        </div>
      </div>
    );
  }
}
